const AUTH_TOKEN_KEY = "auth_token";

export function initializeAuthFromUrl() {
  const url = new URL(window.location.href);
  const authToken = url.searchParams.get("authToken");

  if (!authToken) return;

  localStorage.setItem(AUTH_TOKEN_KEY, authToken);

  // Optional but recommended: remove token from URL
  url.searchParams.delete("authToken");
  window.history.replaceState({}, document.title, url.toString());
}